import * as React from 'react';
import { NavLink } from "react-router-dom";
import * as classNames from "classnames";
import { ThemeContext } from '../../../../app';

const InternalClassificationNavLink = (route: string, label: string, icon: string, className: string) => {
    return <ThemeContext.Consumer
        key={`navlink-${label}`}
    >
        {classification => <NavLink
            className={className}
            activeClassName="active"
            to={`/${classification.route.length > 1 ? classification.route + '/' : ''}${route}`}
        >
            {icon ? <i className={classNames("fa", icon)} aria-hidden="true"></i> : null}
            {label}
        </NavLink >}
    </ThemeContext.Consumer>
};

export default InternalClassificationNavLink;